
import React, { useState, useEffect } from 'react';
import tapIcon from '../../../services/TapIcon';
import Ax from "../../../components/hoc/Ax";
import { connect, useSelector } from 'react-redux';
import Loader from "../../../components/ui/Loader/Loader";
import AppBaseComponent from "../../../components/AppBaseComponent";
import HttpAPICall from "../../../services/HttpAPICall";
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import { Helmet } from 'react-helmet';
import { BACKOFFICE_BASE_URL } from '../../../services/TapApiUrls';
import { toast } from 'react-toastify';

const SubSectionAdd = ({ history, location }) => {

    const subSectionUrl =   BACKOFFICE_BASE_URL + '/sub_section'; 

    const initAddSubSectionForm = {
        name: '',
        notes: ''
    };

    const [saveFormSubmitting, setSaveFormSubmitting] = useState(false);
    const [addSubSectionForm, setAddSubSectionForm] = useState({ ...initAddSubSectionForm });
    const [formLoading, setFormLoading] = useState(false);
    const [editResource, setEditResource] = useState(false);
    const access_token = useSelector(state => state.auth.access_token);

    const [editName, setEditName]   =   useState('');
    const [nameExit, setNameExit]   =   useState(false);
    const [searchExitName, setSearchExitName] = useState(false);

    useEffect(() => {
        getAddFormData()
    }, []);

    const closeEvent = () => {
        setAddSubSectionForm({ ...initAddSubSectionForm });
        setEditName('');
        setNameExit(false);
        history.push({ pathname: `/sub_section_list` });
    };
    const getAddFormData = () => {
        setFormLoading(true);
        if (location.state && location.state.editSubSectionData) {
            let detail = location.state.editSubSectionData;
            setEditName(detail.subcomponent);
            setAddSubSectionForm({
                ...initAddSubSectionForm,
                id: detail.id,
                name: detail.subcomponent,
                notes: detail.description ? detail.description : "",
            });
            setEditResource(true);
        }
        setFormLoading(false);
    };

    const submitAddSubSectionForm = (e) => {
        e.preventDefault();
        const formData = {
            ...addSubSectionForm,
        };
        if (editResource) {
            setSaveFormSubmitting(true);
            HttpAPICall.withAthorization('PUT', subSectionUrl + '/edit', access_token, {}, { ...formData }, (resp) => {
                toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
                closeEvent();
            }).then(() => setSaveFormSubmitting(false));
        } else {
            setSaveFormSubmitting(true);
            HttpAPICall.withAthorization('POST', subSectionUrl + '/add', access_token, {}, { ...formData }, (resp) => {
                toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
                closeEvent();
            }).then(() => setSaveFormSubmitting(false));
        }

    };

    const formInputHandler = (e, formName) => {
        const { name, value } = e.target;
        if (formName === "addSubSectionForm") {
            setAddSubSectionForm(prevState => ({ ...prevState, [name]: value }));
        }
    };

    const handleBlur    =   ()  => {
        const {name} = addSubSectionForm
        if(name && name !== editName) {
            setEditName(name);
            setSearchExitName(true);
            HttpAPICall.withAthorization('GET', subSectionUrl + '/with_name?name=' + name, access_token, {}, {}, (resp) => {
                if(resp.data > 0) {
                    setNameExit(true)
                }else {
                    setNameExit(false)
                }
            }).then(() => setSearchExitName(false));
        }
    }

    const saveSubSectionFormJsx = () => {
        return (
            <form className="bg-white p-3" onSubmit={submitAddSubSectionForm} id="saveResourceForm">
                {formLoading ? <Loader />
                    : <Ax>
                        <div className="row align-items-center my-3">
                            <div className="col-sm-3">
                                <label htmlFor="name" className="form-label require">Name</label>
                            </div>
                            <div className="col-sm-6">
                                <input
                                    name="name"
                                    type="text"
                                    value={addSubSectionForm.name}
                                    className="form-control"
                                    autoComplete="off"
                                    required={true}
                                    onChange={(e) => formInputHandler(e, "addSubSectionForm")}
                                    onBlur={handleBlur}
                                    placeholder="Please enter Name"
                                />
                                {
                                nameExit && 
                                <span className="text-danger">* Sub Section not available,try another</span>
                                }
                            </div>
                        </div>
                        <div className="row align-items-center my-3">
                            <div className="col-sm-3">
                                <label htmlFor="notes" className="form-label require">Notes</label>
                            </div>
                            <div className="col-sm-6 add_calender_section">
                                <textarea
                                    name="notes"
                                    value={addSubSectionForm.notes}
                                    onChange={(e) => formInputHandler(e, 'addSubSectionForm')}
                                    className="form-control"
                                    style={{ height: "100px" }}
                                    required={true}
                                />
                            </div>
                        </div>
                    </Ax>}
                <div className="col-12 text-end fixed_footer">
                    <button type="button" disabled={saveFormSubmitting} onClick={closeEvent} className="btn btn-secondary mx-3">Cancel</button>
                    <button type="submit" disabled={saveFormSubmitting || searchExitName} className="btn btn-primary mx-2">
                        Save {saveFormSubmitting ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}
                    </button>
                </div>
            </form>
        );
    };

    return (
        <ApplicationLayout>
            <Helmet><title>SubSection Add</title></Helmet>
            <div className="page_title row m0">
                <div className="col-12">
                    <h3>{editResource ? "Edit" : "Add"} SubSection</h3>
                    <div className="text-end mt15">
                        <button onClick={closeEvent} disabled={saveFormSubmitting} type="button" className="btn btn-secondary">
                            <tapIcon.imageIcon icon={tapIcon.CloseIcon} className="img-fluid" alt="Close Fuel Station" />
                        </button>
                    </div>
                </div>
            </div>
            <div className="container-fluid">
                <div className="page_containt row pl2">
                    <div className="pageTbl col-12 pl4">
                        {saveSubSectionFormJsx()}
                    </div>
                </div>
            </div>
        </ApplicationLayout>
    );
};


export default SubSectionAdd;
